var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"followers-wrapper"},[_c('div',{staticClass:"follower-count text-center"},[_c('span',[_vm._v("Followers")]),_c('h3',[_vm._v(_vm._s(_vm.followerCount))])]),_c('div',{staticClass:"following-count text-center"},[_c('span',[_vm._v("Following")]),_c('h3',[_vm._v(_vm._s(_vm.followingCount))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }